// extracted by mini-css-extract-plugin
module.exports = {"wrap":"game-list_wrap_1wb8k","gameList":"game-list_gameList_pgKIb","moreGame":"game-list_moreGame_3winZ"};